// extracted by mini-css-extract-plugin
module.exports = {"logoButton":"wTGWeBuy","header":"mtx3zZQf","styledLogotype":"uQM6g2_b","categories":"GFYKZHpN"};